import React from "react";
import { HeaderNavLink } from "..";

type CommunityNavProps = {
  isActive: any;
  setIsActive: any;
}

const CommunityNav: React.FC<CommunityNavProps> = ({isActive, setIsActive}) => {

  const handleActive = (pageName: 'Discuss' | 'Members' | 'Media' | 'Files') => {
    setIsActive(pageName);
  };
 

  return (
    <>
      <div className="w-full mt-4 px-4 lg:px-0 relative">
        <ul className="lg:bg-white bg-[#2157590F] rounded shadow-sm flex h-10 text-center items-center w-full">
          <HeaderNavLink
            active={isActive === 'Discuss'}
            onClick= {() => handleActive('Discuss')}
          >
            Discuss
          </HeaderNavLink>
          <HeaderNavLink
            active={isActive === 'Members'}
            onClick= {() => handleActive('Members')}
          >
            Members
          </HeaderNavLink>
          <HeaderNavLink
            active={isActive === 'Media'}
            onClick= {() => handleActive('Media')}
          >
            Media
          </HeaderNavLink>
          {/* <HeaderNavLink
            active={isActive === 'Files'}
            onClick= {() => handleActive('Files')}
          >
            Files
          </HeaderNavLink> */}
        </ul>
      </div>
    </>
  );
};

export default CommunityNav;
